import { isEmail } from 'validator';

import {
  addressProperties,
  addressRequired,
  customValidate
} from 'common/components/address/validators';
import { validateForUI } from 'common/helpers/jsonValidator';

const customerSchema = () => {
  const schema = {
    type: 'object',
    properties: addressProperties,
    required: addressRequired,
    additionalProperties: false
  };
  schema.properties.emailMarketingStatus = { type: 'string' };
  schema.properties.email = { type: 'string' };
  schema.properties.password = { type: 'string', minLength: 8 };
  schema.properties.confirmPassword = { type: 'string', minLength: 8 };
  schema.required = [
    ...schema.required,
    'email',
    'password',
    'confirmPassword'
  ];
  return schema;
};

export const validateAdd = (customer, settings) => {
  const errors = validateForUI(
    customerSchema(),
    customer,
    customValidateAddress(customer, settings)
  );
  return errors;
};

const customValidateAddress = (customer, settings) => {
  const errorArray = customValidate(customer, 'addressBook', settings);
  if (customer.email && !isEmail(customer.email)) {
    const error = { field: `email`, message: 'Invalid Email' };
    errorArray.push(error);
  }

  if (customer.password !== customer.confirmPassword) {
    const error = {
      field: 'confirmPassword',
      message: 'Confirm Password must match Password'
    };
    errorArray.push(error);
  }
  return errorArray;
};
